import React from 'react';

import { Badge } from 'components/Badge';
import { INVOICE_STATUS_COLOR_MAP } from 'scenes/FinancePage/FR/constants';

interface StatusConfig {
  value: { id: number; name: string };
  slot?: any;
}

const Status: React.FC<StatusConfig> = ({ value, children, ...props }) => {
  const color = INVOICE_STATUS_COLOR_MAP.get(value?.id);
  return (
    <Badge color={color} {...props}>
      {value?.name}
    </Badge>
  );
};
export default Status;
